jQuery( document ).ready( function( $ ) {
  // Make mobile category selector go to tag page
  $( '.article__recommendedFilter select' ).on( 'change', function() {
    var tagUrl = $( this ).val();
    
    if (tagUrl != 'null') {
      window.location = tagUrl;
    }
  } );
});